import { ContactsOutlined } from '@mui/icons-material'
import { Brick, registerBrick, Config } from 'olympe'

export default class GetSAMLDetails extends Brick {
    /**
     * Executed every time the brick receives a new trigger event.
     * Note that the method will be executed _even if_ an input () is undefined.
     *
     * @protected
     * @param {BrickContext} context
     * @param {!Array} inputs
     * @param {function()} forwardEvent
     * @param {function(string)} setUserName
     * @param {function(string)} setFullName
     * @param {function(string)} setEmail
     * @param {function(string)} setSAMLToken
     */
    onUpdate(context, inputs, [forwardEvent, setUserName, setFullName, setEmail, setSAMLToken, setErrorFlow]) {
        const olympeDB = Config.getParameter('olympe_db')
        const store = Config.getParameter('db_store')
        const key = Config.getParameter('local_storage_SAML_key')

        const DBConnexion = indexedDB.open(olympeDB)
        DBConnexion.onerror = event => console.error(`Error opening the Olympe Local DB ${event}`)
        DBConnexion.onsuccess = event => {
            const db = event.target.result
            const transaction = db.transaction([store], 'readonly')
            const authStore = transaction.objectStore(store)
            const request = authStore.get(key)

            request.onsuccess = event => {
                const details = decodeURIComponent(escape(window.atob(event.target.result)))
                const userData = JSON.parse(details)

                // Fix in case we login with another SAML provider
                if (
                    !userData.payload ||
                    userData.payload['http://schemas.microsoft.com/identity/claims/identityprovider'] !==
                        Config.getParameter('saml_provider')
                ) {
                    console.error('Wrong SAML provider')
                    db.close()
                    setErrorFlow('Wrong SAML provider')
                } else {
                    setUserName(userData.payload['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name/name'])
                    setFullName(
                        userData.payload['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/givenname'] +
                            ' ' +
                            userData.payload[
                                'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/surname'
                            ].toUpperCase()
                    )
                    setEmail(userData.payload['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress'])
                    setSAMLToken(userData.fullToken)
                    db.close()
                    forwardEvent()
                }
            }
            request.onerror = event => {
                console.error('Error getting the SAML data')
                db.close()
            }
        }
        forwardEvent()
    }
}

registerBrick('017cea96041c64884bfc', GetSAMLDetails)
